import NotFoundPage from "../components/NotFoundPage/NotFoundPage";


const NotFound = () => {
    return <NotFoundPage />
}

export default NotFound;
